export const searchTypes = ['address', 'place']
export const mapBoxProxyToken = 'GOcoIleTBepkSmMsxwFi1DaClv6Nj5o8qYwUX6Z9'
